import React from 'react';
import ITService from '../images/it.svg';
import { Link } from 'react-router-dom';
import { FaCloud, FaLock, FaMobileAlt, FaDesktop } from 'react-icons/fa';
import SubserviceDetailComponent from '../components/SubserviceDetailComponent';

const services = [
  {
    icon: <FaCloud />,
    title: 'Technical Training',
    description: 'Enhance your team’s technical skills with our training programs. We offer courses and workshops to boost proficiency in various IT areas.',
  },
  {
    icon: <FaLock />,
    title: 'End-User Training',
    description: 'Improve user adoption and efficiency with end-user training. Our sessions cover software and system use to maximize productivity.',
  },
  {
    icon: <FaMobileAlt />,
    title: 'Certification Preparation',
    description: 'Prepare for IT certifications with our tailored programs. We provide resources and training to help you achieve your certification goals.',
  },

  {
    icon: <FaMobileAlt />,
    title: 'Customised Workshops',
    description: 'Attend customized workshops designed for your specific needs. We create hands-on sessions to address unique challenges and objectives.',
  },
];

const ITTraining = () => {
  return (
    <div className = "relative">
      <img
        className="h-auto w-full object-cover"
        src={ITService}
        alt="IT Services"
      />

      <div>

      <section className='text-left mt-6'>
      <h1 className="text-center my-6 text-2xl font-semibold">IT Training & Development</h1>
      </section>
     

      <section>
        <SubserviceDetailComponent services={services}/>
        <div className='mb-6'>
      <h2 className="text-xl font-semibold mb-6 mx-6">Get Started with Expert IT Services</h2>
      <p className="text-md text-black mb-6 px-12 text-left">
      Maximize efficiency, enhance security, and drive growth with our tailored IT Services. Our certified experts provide 24/7 support, proactive monitoring, and strategic IT planning to meet your business needs.
      </p>
      
      <Link to="/contact"
        className="inline-block bg-[#13689b] text-white py-3 px-6 rounded-md text-md font-semibold transition-transform transform hover:scale-105">
      Contact Us
      </Link>
      </div>
      </section>

    </div>

    </div>
  )
}

export default ITTraining
